export function compactSaleId(value: string): string {
  if (value.length <= 18) return value

  if (value.startsWith('invoice:')) {
    const cycle = value.slice(value.lastIndexOf(':') + 1)
    return `invoice:…:${cycle}`
  }

  if (value.startsWith('funnel:')) {
    const parts = value.split(':')
    const origin = parts[1]
    const offer = parts.at(-1)
    return origin && offer ? `funnel:${compactSaleId(origin)}:${compactSaleId(offer)}` : 'funnel:…'
  }

  if (value.startsWith('sale_')) {
    return `${value.slice(0, 10)}…${value.slice(-6)}`
  }

  return `${value.slice(0, 8)}…${value.slice(-6)}`
}

export function saleIdLabel(value: string): string {
  return `#${compactSaleId(value)}`
}
